var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg-sprite-dd550b242a3b6b8a5a6248c8d85caec3.svg#icon-appstore-a769a';
                    var viewUrl = 'svg-sprite-dd550b242a3b6b8a5a6248c8d85caec3.svg#view-icon-appstore-a769a';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 120 40',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };